import Vue from 'vue'
import Vuex from 'vuex'
import { AppState } from './modules/app'
import { UserState } from './modules/user'
import { CommonState } from './modules/common'
import { PortState } from './modules/portfolio'
import { AnalyState } from './modules/analy'
import { PersionState } from './modules/pension'

Vue.use(Vuex)

export interface RootState {
  app: AppState;
  user: UserState;
  common: CommonState;
  port: PortState;
  analy: AnalyState;
  Persion: PersionState
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<RootState>({})
